import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { IServiceMappingModel } from "src/app/components/master-data/service-mapping-form/service-mapping.model";
import { BackendListModel } from "src/app/models/common/list.model";
import { ApiRoutes } from "../apiroutes";
import { ServiceMasterModel } from "src/app/models/common/service-master.model";

@Injectable({
  providedIn: 'root'
})
export class ServiceMappingApiService {

  selectedMappingId;
  selectedMap;
  selectedMapTableData;

  base_url = ApiRoutes.UserService;

  constructor(
    private http: HttpClient
  ) { }

  getUserServiceList(): Observable<BackendListModel<ServiceMasterModel>> {
    const url = `${this.base_url}service_master/`;
    return this.http.get<BackendListModel<ServiceMasterModel>>(url);
  }

  getUserRegionMapping(page_size = 10, page = 1, search = '', order = ''): Observable<BackendListModel<IServiceMappingModel>> {
    const url = `${this.base_url}user_service/`;
    let urlObj = new URL(url);
    urlObj.searchParams.append('page_size', String(page_size));
    urlObj.searchParams.append('page', String(page));
    urlObj.searchParams.append(`search`, String(search));
    urlObj.searchParams.append('o', String(order));
    return this.http.get<BackendListModel<IServiceMappingModel>>(String(urlObj));
  }

  getUserRegionMappingById(id): Observable<IServiceMappingModel> {
    const url = `${this.base_url}user_service/${id}`;
    return this.http.get<IServiceMappingModel>(url);
  }

  getUserRegionMappedPortList(id, page_size = 10, page = 1, search = '', order = ''): Observable<BackendListModel<any>> {
    const url = `${this.base_url}user_service_port_list/${id}/`;
    let urlObj = new URL(url);
    urlObj.searchParams.append('page_size', String(page_size));
    urlObj.searchParams.append('page', String(page));
    urlObj.searchParams.append(`search`, String(search));
    urlObj.searchParams.append('o', String(order));
    return this.http.get<BackendListModel<any>>(String(urlObj));
  }

  saveUserRegionMapping(data: IServiceMappingModel) {
    const url = `${this.base_url}user_service/`;
    return this.http.post(url, data);
  }

  deletePortCombo(id) {
    const url = `${this.base_url}user_service_port_mapping/${id}/`;
    return this.http.delete(url);
  }

  updateUserMappingPorts(data): Observable<any> {
    const url = `${this.base_url}multiple_user_service_port_mapping/`;
    return this.http.post(url, data);
  }
}